export interface IEntity<TId> {
  id: TId;
}

export function instanceOfIEntity<TId>(instance: any): instance is IEntity<TId> {
  return instance
    && (instance.id !== undefined);
}
